import { render, staticRenderFns } from "./RegistrationComplete.htm?vue&type=template&id=6d968d7c&scoped=true&"
import script from "./RegistrationComplete.ts?vue&type=script&lang=js&"
export * from "./RegistrationComplete.ts?vue&type=script&lang=js&"
import style0 from "./RegistrationComplete.scss?vue&type=style&index=0&id=6d968d7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d968d7c",
  null
  
)

export default component.exports